import actions from './actions';

const { READ_MESSAGE_BEGIN, READ_MESSAGE_SUCCESS, READ_MESSAGE_ERR } = actions;

const initialState = [];

const initialStateFilter = {
  data: [],
  loading: false,
  error: null,
};

const readMessageReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case READ_MESSAGE_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case READ_MESSAGE_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };
    case READ_MESSAGE_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { readMessageReducer };
